(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function initProductSearch(scope) {
    var blocks = (scope || document).querySelectorAll('[data-product-search]');

    blocks.forEach(function (block) {
      if (block.dataset.productSearchInit === 'true') {
        return;
      }
      block.dataset.productSearchInit = 'true';

      var input = block.querySelector('[data-product-search-input]');
      var hidden = block.querySelector('[data-product-search-value]');
      var results = block.querySelector('[data-product-search-results]');
      var selectedList = block.querySelector('[data-product-search-selected]');
      var removeLabel = block.dataset.removeLabel || 'Remove';

      if (!input || !hidden || !results || !selectedList) {
        return;
      }

      var timeout;
      var currentQuery = '';
      var selectedProducts = [];

      function hideResults() {
        results.classList.add('hide');
        results.innerHTML = '';
      }

      function renderSelected() {
        if (!selectedProducts.length) {
          selectedList.classList.add('hide');
          selectedList.innerHTML = '';
          hidden.value = '';
          return;
        }

        selectedList.classList.remove('hide');
        selectedList.innerHTML = selectedProducts
          .map(function (product, index) {
            return (
              '<li class="contact-product-search__selected-item">' +
              '<span class="contact-product-search__selected-title">' +
              escapeHtml(product.title) +
              '</span>' +
              '<button type="button" class="contact-product-search__remove" data-index="' +
              index +
              '">' +
              escapeHtml(removeLabel) +
              '</button>' +
              '</li>'
            );
          })
          .join('');

        hidden.value = selectedProducts
          .map(function (product) {
            return product.value;
          })
          .join(', ');

        selectedList.querySelectorAll('.contact-product-search__remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var index = parseInt(btn.getAttribute('data-index'), 10);
            selectedProducts.splice(index, 1);
            renderSelected();
          });
        });
      }

      function addProduct(title, value) {
        var exists = selectedProducts.some(function (product) {
          return product.value === value;
        });

        if (!exists) {
          selectedProducts.push({ title: title, value: value });
          renderSelected();
        }

        input.value = '';
        currentQuery = '';
        hideResults();
        input.focus();
      }

      function renderResults(products) {
        if (!products.length) {
          hideResults();
          return;
        }

        var markup = products
          .map(function (product) {
            var image =
              product.featured_image && product.featured_image.url
                ? product.featured_image.url
                : product.image || '';
            var value = product.title + ' (' + product.handle + ')';
            var imgMarkup = image ? '<img src="' + image + '" alt="" loading="lazy">' : '';
            return (
              '<button type="button" class="contact-product-search__result" ' +
              'data-title="' +
              escapeHtml(product.title) +
              '" ' +
              'data-value="' +
              escapeHtml(value) +
              '">' +
              imgMarkup +
              '<span class="contact-product-search__result-title">' +
              escapeHtml(product.title) +
              '</span>' +
              '</button>'
            );
          })
          .join('');

        results.innerHTML = markup;
        results.classList.remove('hide');

        results.querySelectorAll('.contact-product-search__result').forEach(function (btn) {
          btn.addEventListener('click', function () {
            addProduct(btn.getAttribute('data-title'), btn.getAttribute('data-value'));
          });
        });
      }

      function runSearch(query) {
        if (query === currentQuery) {
          return;
        }
        currentQuery = query;

        var params = [
          'q=' + encodeURIComponent(query + '*'),
          'resources[type]=product',
          'resources[limit]=6',
          'resources[options][fields]=title,product_type,variants.title,vendor'
        ].join('&');

        fetch('/search/suggest.json?' + params)
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var products =
              (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products);
          })
          .catch(function () {
            hideResults();
          });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearTimeout(timeout);

        if (query === '') {
          currentQuery = '';
          hideResults();
          return;
        }

        timeout = setTimeout(function () {
          runSearch(query);
        }, 300);
      });

      document.addEventListener('click', function (evt) {
        if (!block.contains(evt.target)) {
          hideResults();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductSearch(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initProductSearch(evt.target);
  });
})();
